import PropTypes from "prop-types";

GlobalError.propTypes = {
  resetErrorBoundary: PropTypes.func,
  error: PropTypes.shape({ message: PropTypes.string }),
};

export default function GlobalError({
  error,
  resetErrorBoundary = () => window.location.reload(),
}) {
  return (
    <div className="w-full h-full  flex justify-center items-center">
      <div className="card bg-base-100 bordered shadow-lg">
        <div className="card-body min-w-64">
          <h1 className="card-title">Error</h1>
          <p>The following error occurred when routing:</p>
          <pre className="bg-black text-red-500 px-4 py-2">{error.message}</pre>
          <div className="card-actions justify-end mt-2">
            <button type="button" className="btn btn-secondary btn-sm" onClick={resetErrorBoundary}>
              Retry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
